<div class="flex flex-col items-center font-main text-navy-90 max-w-150 m-auto">
  <svg-icon [src]="'empty-trust'"></svg-icon>
  <p class="font-bold text-4xl mt-8">{{ buildTranslationKey('title') | translate }}</p>
  <p class="text-base text-center my-5.5 mx-10">{{ buildTranslationKey('description') | translate }}</p>
  <div>
    <app-new-button [type]="'primary'" [size]="'responsive'" [svgIconPath]="'Help'" (click)="contactUs()">
      {{ buildTranslationKey('contactUsBtn') | translate }}
    </app-new-button>

    <app-new-button
      class="ml-3"
      [type]="'secondary'"
      [size]="'responsive'"
      [svgIconPath]="'newscreen'"
      (click)="learnMoreAboutTrustCenter()"
    >
      {{ buildTranslationKey('learnMoreBtn') | translate }}
    </app-new-button>
  </div>
</div>
